import { useMediaQueryDevice } from '@/components/MediaQuery';
import { TabType } from '@/constants';
import { setTabType } from '@/features/global/actions';

import { useAppDispatch } from '@/hooks';
import { useGa } from '@/hooks/useGa';

import { useChainShortName } from '@/hooks/web3/useChain';
import { GaCategory } from '@/utils/analytics';
import { useLocalStorageState } from 'ahooks';
import classNames from 'classnames';
import _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import './Menu.less';
import HeaderMenuDropdown from './headerMenuDropdown/HeaderMenuDropdown';

export default function HeaderMenu(): JSX.Element {
  const { deviceType } = useMediaQueryDevice();
  const location = useLocation();

  const dispatch = useAppDispatch();
  const gaEvent = useGa();

  const [menuType, setMenuType] = useState('');
  const { t } = useTranslation();
  // const ooDappConfig = useOdysseyDappConfig();
  const [lastFutures] = useLocalStorageState('last_futures', { defaultValue: 'trade', listenStorageChange: true });
  const onMenuClick = useCallback(
    (menuKey: string, isExternalLink?: boolean) => {
      document.getElementById('pageLayout')?.scroll({ top: 0 });
      !isExternalLink && setMenuType(menuKey);
    },
    [setMenuType],
  );

  useEffect(() => {
    const urlType = _.get(location.pathname.split('/'), [1]) || '';
    if (urlType === 'trade' || urlType === 'earn') {
      setMenuType('futures');
    } else {
      setMenuType(urlType);
    }
    if (Object.values(TabType).includes(urlType as TabType)) {
      dispatch(setTabType({ type: urlType as TabType }));
    }
  }, [dispatch, location.pathname]);

  const chainShortName = useChainShortName();

  return (
    <>
      <ul className={`header-menu ${deviceType}`}>
        {/* <li>
          <Link
            className={classNames('header-item', menuType === 'market' && 'header-item-selected')}
            to={`/market`}
            onClick={() => {
              onMenuClick('market');
              gaEvent({ category: GaCategory.HEADER, action: 'Menu-Click on market' });
            }}>
            <span>{t('header.menu.Market')}</span>
          </Link>
        </li> */}
        <li>
          <Link
            className={classNames('header-item', menuType === 'futures' && 'header-item-selected')}
            to={`${lastFutures === 'earn' ? '/earn' : `/trade`}/${chainShortName}`}
            onClick={() => {
              onMenuClick('futures');
              gtag('event', 'enter_futures', {
                entrance: 'nav_bar', // link, nav_bar, market, portfolio, odyssey_place_limit_order
              });
            }}>
            <span>{t('header.menu.Futures')}</span>
          </Link>
        </li>

        <li>
          <Link
            className={classNames('header-item', menuType === 'portfolio' && 'header-item-selected')}
            to={`/portfolio`}
            onClick={() => {
              onMenuClick('portfolio');
              gaEvent({ category: GaCategory.HEADER, action: 'Menu-Click on Portfolio' });
            }}>
            <span>{t('header.menu.Portfolio')}</span>
          </Link>
        </li>

        <li>
          <HeaderMenuDropdown />
        </li>
      </ul>
    </>
  );
}
